// extracted by mini-css-extract-plugin
export var swiper = "styles-module--swiper--2Zj-D";
export var swiper_cont = "styles-module--swiper_cont--3eGGo";
export var swiper_cntrls = "styles-module--swiper_cntrls--2litc";
export var swiper_pagin = "styles-module--swiper_pagin--l73sC";
export var swiper_btn = "styles-module--swiper_btn--3Mai2";